import React, { useMemo, useRef } from 'react';
import { Space, Row, Col, Switch, Tag } from 'antd';
import { StarFilled } from '@ant-design/icons';
import TableFetchData from '../../components/data-table/TableFetchData';
import MagazineCard from '../../components/magazine/MagazineCard';
import EditTableSvg from '../../assets/images/EditTable';
import DeleteTableSvg from '../../assets/images/DeleteTable';
import { useTranslation } from 'react-i18next';
import MagazineModal from '../../components/magazine/MagazineModal';
import { ImageNo } from '../../components/image/ImageComponent';
import { formatDateTime } from '../../utils/dateFormatUtils';
import { useNavigate } from 'react-router-dom';
import { putDataRequest } from '../../api/serviceMethods';
import { PRODUCT_URL } from '../../api/URLs';
import MessageConfirmModal from '../../components/messageModal/MessageConfirmModal';
import TagTextComponent from '../../components/tag/TagTextComponent';

const TableListProduct = ({ 
  viewType, magazineData, tableParams,
   setTableParams, loading, setLoading,
   hadleUpdateMagazine, deleteMagazineData, 
   initLoadProduct
}) => {
  const { t } = useTranslation();
  const messageModalRef = useRef('');
  // new code for view pdf
  const magazineRef = useRef();
  const appDownloadRef = useRef();
  const navigate = useNavigate();
  const handleShowMagazine = async (item) => {
    magazineRef.current?.showModal(item);
  };
  const handleCloseDownloadApp = () => appDownloadRef.current?.closeModal();

  const sortedData = useMemo(() => {
    if (!magazineData || !Array.isArray(magazineData)) return [];
    return [...magazineData].sort((a, b) => {
      const aFeature = a?.isFeature ? 1 : 0;
      const bFeature = b?.isFeature ? 1 : 0;
      return bFeature - aFeature;
    });
  }, [magazineData]);

  const handleStatus = async (item) => {
    try {
      setLoading(true);
      await putDataRequest(`${PRODUCT_URL}/${item._id || item.id}/status`, { status: !item.status } )
        .then((res) => {
          if (res.status === 200) {
            messageModalRef.current.showSuccessConfirmsAutoClose(t(res && res.message), () => { }, "", true);
            initLoadProduct('');
            setTimeout(() => {
              setLoading(false);
            }, 2000);
          } else {
            messageModalRef.current.showWarningConfirmsAutoClose(res && res.message, () => { }, "", true);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          messageModalRef.current.showWarningConfirmsAutoClose(err && err.response && err.response.data && err.response.data.message || `Server Error!`, () => { }, "", true);
        });
    } catch (error) {
      setLoading(false);
      messageModalRef.current.showWarningConfirmsAutoClose(`Server Error!`, () => { }, "", true);
    }
  };

  const tableSettings = {
    appendable: false,
    removable: false,
    bordered: true,
    size: "small",
    pagination: {
      showLessItems: true,
      pageSize: 10,
    },
    columns: [
      {
        title: <label className="titleCard14400">{t("Product Photo")}</label>,
        render: (_, record) => (
          <div style={{ position: "relative", width: "80px", height: "85px" }}>
            <img
              style={{ width: "80px", height: "85px", borderRadius: "6px", objectFit: "cover" }}
              src={(record && record.images && record.images[0]?.url) || ImageNo}
              alt="product"
            />
            {record?.isFeature && (
              <div
                style={{
                  position: "absolute",
                  top: "3px",
                  left: "3px",
                  backgroundColor: "#E50A47",
                  color: "white",
                  fontSize: "10px",
                  fontWeight: 600,
                  padding: "1px 5px",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  gap: "2px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.25)"
                }}
              >
                <StarFilled style={{ fontSize: "10px" }} />
                {t("Feature")}
              </div>
            )}
          </div>
        )
      },
      {
        title: <label className="titleCard14400">{t("Product Name")}</label>,
        render: (_, record) => (
          <div className="d-flex align-items-center" style={{ gap: "8px" }}>
            <label className="text-capitalize">{record && record.name}</label>
            {record?.isFeature && (
              <Tag
                style={{
                  borderRadius: "4px",
                  fontSize: "11px",
                  padding: "1px 6px",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "3px",
                  fontWeight: 500,
                  border: "none",
                  backgroundColor: "#FDECF1",
                  color: "#E50A47",
                }}
              >
                <StarFilled style={{ fontSize: "11px", color: "#E50A47" }} />
                {t("Feature")}
              </Tag>
            )}
          </div>
        )
      },
      {
        title: <label className="titleCard14400">{t("Product Category")}</label>,
        render: (_, record) => (
          <>
            <TagTextComponent textData={record.categoryId ? [record.categoryId.name] : []} />
          </>
        )
      },
      {
        title: <label className="titleCard14400">{t('Product Price')}</label>,
        render: (_, record) => (
          <label className="text-capitalize">{`￥${record && record?.price}`}</label>
        )
      },
      {
        title: <label className="ant-table-column-title titleCard14400">{t('Creation Time')}</label>,
        dataIndex: 'sortByDate',
        sorter: true,
        key: 'sortByDate',
        render: (_, record) => (
          <label className="text-capitalize">{record && record.createdTS && formatDateTime(record.createdTS)}</label>
        )
      },
      {
        title: <label className="titleCard14400">{t('Operator')}</label>,
        key: 'action',
        render: (_, record) => (
          <Space size="middle">
            <Switch onChange={() => handleStatus(record)} checked={record.status} />
            <span style={{ cursor: "pointer" }} onClick={() => navigate(`/product/${record._id}`)}>
              <EditTableSvg />
            </span>
            <span style={{ cursor: "pointer" }} onClick={() => deleteMagazineData(record)}>
              <DeleteTableSvg />
            </span>
          </Space>
        ),
      },
    ],
  };

  return (
    <div>
      <Row gutter={16} align="middle" style={{ marginBottom: 16 }}>
        <Col style={{ marginLeft: 'auto' }}>
        </Col>
      </Row>

      {viewType === 'table' ? (
        <TableFetchData
          tableParams={tableParams}
          setTableParams={setTableParams}
          data={sortedData}
          columns={tableSettings.columns}
          loading={loading}
          setLoading={setLoading}
        />
      ) : (
        <MagazineCard 
          magazineData={sortedData} setLoading={setLoading} 
          loading={loading} tableParams={tableParams}
          tableSettings={tableSettings}
          setTableParams={setTableParams}
          hadleUpdateMagazine={hadleUpdateMagazine}
          deleteMagazineData={deleteMagazineData}
          handleShowMagazine={handleShowMagazine}
          navigate={navigate}
          t={t}
        />
      )}
      <MagazineModal
        ref={magazineRef}
        handleCloseDownloadApp={handleCloseDownloadApp}
      />
      <MessageConfirmModal textCentered ref={messageModalRef} />
    </div>
  );
};

export default TableListProduct;
